<div class="wz-grid">
  <div class="wz-main">
    <app-campaign-details-form></app-campaign-details-form>
  </div>

  <aside class="wz-aside" aria-label="Campaign summary">
    <app-campaign-details-preview></app-campaign-details-preview>
  </aside>
</div>
